import { TASK_INSTANCE_COMPLETED_STATUS } from '../../constants';
import canInteractWithTaskInstance from './canInteractWithTaskInstance';

export default function canInteractWithSubtasks(taskInstance, user) {
  if (taskInstance.status === TASK_INSTANCE_COMPLETED_STATUS) {
    return false;
  }

  return canInteractWithTaskInstance(taskInstance, user);
}
